import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { getSubject } from '../authz/subject.js';
import { Teacher } from '../teacher.js';

export const getTeacherByUserIdQuery = registerQuery({
  operationName: 'getTeacherByUserIdQuery',

  type: () => [Teacher],
  params: [{ name: 'userID', type: () => String }],

  resolve: (userID: string) => async (selection: BaseQLSelectionSet<Teacher>) => {
    // Self only: every client asks for its own profile. Any other userID yields nothing.
    const subject = await getSubject();
    if (!subject.userID || userID !== subject.userID) return [];

    const teacherCollection = await getCollection(Teacher);

    const teachers = await teacherCollection.find({ userID }).toArray();

    const normalizedTeachers = teachers.map((teacher: any) => ({
      ...teacher,
      _class: teacher?._class || 'Teacher',
    }));

    return normalizedTeachers as Teacher[];
  },
});
